"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * 折疊樹狀
 */
const {
  Panel
} = _antd.Collapse;
const CollapseTree = _ref => {
  let {
    dataFetching = false,
    accordion = true,
    treeData = [],
    panelData = [],
    checkedList = [],
    activeKey = [],
    onChange = () => {},
    onPanelChange = () => {}
  } = _ref;
  const [autoExpandParent, setAutoExpandParent] = (0, _react.useState)(true);
  const onExpand = expandedKeysValue => {
    setAutoExpandParent(false);
  };
  const onCheck = checkedKeysValue => {
    onChange && onChange(checkedKeysValue);
  };
  function callback(key) {
    onPanelChange && onPanelChange(key);
  }
  const collapsible = (0, _react.useMemo)(() => {
    return dataFetching ? "disabled" : "";
  }, [dataFetching]);
  return /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
    activeKey: activeKey,
    collapsible: collapsible,
    accordion: accordion,
    onChange: callback
  }, panelData && panelData.map((item, index) => /*#__PURE__*/_react.default.createElement(Panel, {
    header: item.name,
    key: index
  }, dataFetching ? "loading..." : /*#__PURE__*/_react.default.createElement(_antd.Tree, {
    checkable: true,
    onExpand: onExpand,
    autoExpandParent: autoExpandParent,
    onCheck: onCheck,
    checkedKeys: checkedList,
    treeData: treeData,
    selectable: false
  }))));
};
var _default = exports.default = CollapseTree;
CollapseTree.propTypes = {
  activeKey: _propTypes.default.any,
  dataFetching: _propTypes.default.bool,
  accordion: _propTypes.default.bool,
  treeData: _propTypes.default.array,
  panelData: _propTypes.default.array,
  checkedList: _propTypes.default.array,
  onChange: _propTypes.default.func,
  onPanelChange: _propTypes.default.func
};